// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/style.css
// module id = 3573
// module chunks = 31